import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { GenericRichTextDirective } from '@core/jss-utils';
import type { OrderPaymentFormValues } from '@innogy/become-a-customer/state';
import { CommonUiFormsModule } from '@innogy/common-ui/forms';
import { CommonUiProgressiveFormsModule } from '@innogy/common-ui/progressive-forms';
import { MediaObserverService } from '@innogy/shared/responsive-tools';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import {
  ibanConverter,
  IsInvalidPipe,
  AutocompleteDirective,
} from '@innogy/utils-deprecated';
import { InfoCardComponent } from '@legacy/common-ui-utility-components';
import { CSMaskDirective } from '@legacy/utils-contentsquare';

import { OrderFulfillmentStepComponent } from '../order-fulfillment-step.component';
@Component({
  selector: 'wl-order-fulfillment-payment[progressiveFormState]',
  templateUrl: './order-fulfillment-payment.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    CommonModule,
    GenericRichTextDirective,
    CSMaskDirective,
    AutomationIdDirective,
    CommonUiFormsModule,
    CommonUiProgressiveFormsModule,
    InfoCardComponent,
    AutomationIdDirective,
    AutocompleteDirective,
    IsInvalidPipe,
  ],
})
export class OrderFulfillmentPaymentComponent extends OrderFulfillmentStepComponent<OrderPaymentFormValues> {
  public readonly _ibanConverter = ibanConverter;

  readonly deviceInfo = inject(MediaObserverService).deviceInfo;

  readonly labelsShownAboveFields = input(false);
  override readonly progressiveFormCardContent = computed(() => ({
    title: this.orderContent().paymentCardTitle.value ?? '',
    subtitle: this.orderContent().paymentCardSubtitle,
    submitButtonText: this.orderContent().paymentCardSubmitButton,
    stepNumber: this.stepNumber(),
  }));
}
